import DashBoard from "../views/adminPanel/dashboard/DashBoard";

const Links = [
    // tutor Routes
    {
        path: "tutor/profile",
        name: "TPTutorProfile",
        component: () =>
            import ("../views/TutorPanel/profile/TutorProfile.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        }
    },
    {
        path: "tutor/classes",
        name: "TutorClasses",
        component: () =>
            import ("../views/TutorPanel/classes/Classes.vue"),
        meta: {
            panelType: "Tutor",
            icon: "mdi-teach",
            title: "Classes",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "tutor/accounts",
        name: "TutorAccounts",
        component: () =>
            import ("../views/TutorPanel/accounts/Accounts.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "tutor/students",
        name: "TutorStudents",
        component: () =>
            import ("../views/TutorPanel/students/Students.vue"),
        meta: {
            icon: "fas fa-user-graduate",
            title: "TutorStudents",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "tutor/student-profile/:id",
        name: "StudentProfileTP",
        component: () =>
            import ("../views/TutorPanel/student-profile/index.vue"),
        meta: {
            icon: "",
            title: "Student Profile",
            subtitle: "Welcome to QS Learning Student",
        },
    },
    {
        path: "tutor/uploaded-work",
        name: "TutorUploadedWork",
        component: () =>
            import ("../views/TutorPanel/uploadedWork/index.vue"),
        meta: {
            icon: "",
            title: "Student Work",
            subtitle: "Welcome to QS Learning Student",
        },
    },
    {
        path: "tutor/WorkSheet",
        name: "TutorWorkSheet",
        component: () =>
            import ("../views/TutorPanel/workSheet/index.vue"),
        meta: {
            icon: "",
            title: "Student Work",
            subtitle: "Welcome to QS Learning Student",
        },
    },

    // Student Routes
    {
        path: "student/profile",
        name: "StudentProfileSP",
        component: () =>
            import ("../views/StudentPanel/profile/StudentProfile"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        }
    },
    {
        path: "student/classes",
        name: "SPStudentClasses",
        component: () =>
            import ("../views/StudentPanel/classes/Classes.vue"),
        meta: {
            panelType: "Student",
            icon: "mdi-teach",
            title: "Classes",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "student/work",
        name: "StudentWork",
        component: () =>
            import ("../views/StudentPanel/work/Work"),
        meta: {
            icon: "fas fa-file-word",
            title: "Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "student/add-work",
        name: "AddStudentWork",
        component: () =>
            import ("../views/StudentPanel/work/AddWork.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Add Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "student/edit-work",
        name: "EditStudentWork",
        component: () =>
            import ("../views/StudentPanel/work/AddWork.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Edit Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "student/catch-up",
        name: "StudentCatchUp",
        component: () =>
            import ("../views/StudentPanel/catchups/CatchUps.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Catch up Sessions",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "student/add-catchup",
        name: "AddStudentCatchUp",
        component: () =>
            import ("../views/StudentPanel/catchups/AddCatchup.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Add Catchup",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "student/accounts",
        name: "StudentAccounts",
        component: () =>
            import ("../views/StudentPanel/accounts/Accounts.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        },
    },

    {
        path: "student/admission-form",
        name: "AdmissionForm",
        component: () =>
            import ("../views/StudentPanel/admission/Form.vue"),
        meta: {
            icon: "mdi-plus",
            title: "Admission Form",
            subtitle: "Welcome to QS Learning Students",
        },
    },

    {
        path: "student/work-sheet",
        name: "StudentWorkSheet",
        component: () =>
            import ("../views/StudentPanel/StudentWorkSheet/workSheet.vue"),
        meta: {
            icon: "mdi-folder-upload",
            title: "Work Sheet",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "student/upload",
        name: "Upload",
        component: () =>
            import ("../views/StudentPanel/uploads/upload.vue"),
        meta: {
            icon: "mdi-folder-upload",
            title: "Upload",
            subtitle: "Welcome to QS Learning Students",
        },
    },

    // Admin Routes
    {
        path: "dashboard",
        name: "APDashBoard",
        component: DashBoard,
        meta: {
            icon: "mdi-poll-box",
            title: "Dashboard",
            subtitle: "Welcome to QS Learning Dashboard",
        },
    },
    {
        path: "dashboard",
        name: "DashBoard",
        component: DashBoard,
        meta: {
            icon: "mdi-poll-box",
            title: "DashBoard",
            subtitle: "Welcome to QS Learning Dashboard",
        },
    },
    {
        path: "students",
        name: "APStudents",
        component: () =>
            import("../views/adminPanel/students/Students.vue"),
        meta: {
            icon: "fas fa-user-graduate",
            title: "Student",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "edit-student",
        name: "EditStudent",
        props: true,
        component: () =>
            import("../views/adminPanel/students/EditStudent.vue"),
        meta: {
            routeName: "EditStudent",
            icon: "",
            title: "Edit Student",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "student-profile/:id",
        name: "StudentProfile",
        component: () =>
            import("../views/adminPanel/student-profile/index.vue"),
        meta: {
            icon: "",
            title: "Student Profile",
            subtitle: "Welcome to QS Learning Student",
        },
    },
    {
        path: "student-uploaded-work/:id",
        name: "StudentUpload",
        component: () =>
            import("../views/adminPanel/uploads/upload.vue"),
        meta: {
            icon: "mdi-folder-upload",
            title: "Student Upload",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "classes",
        name: "Classes",
        component: () =>
            import("../views/adminPanel/classes/Classes.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Class Management",
            subtitle: "Welcome to QS Learning Classes",
        },
    },

    {
        path: "record-management",
        name: "RecordManagement",
        component: () =>
            import("../views/adminPanel/record-management/Records.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Record Management",
            subtitle: "Welcome to QS Learning Classes",
        },
    },

    {
        path: "edit-admission-form/:id",
        name: "EditAdmissionForm",
        props: true,
        component: () =>
            import("../views/adminPanel/admission/Form.vue"),
        meta: {
            routeName: "EditAdmissionForm",
            icon: "",
            title: "Edit Addmission Form",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "record-management/edit-joined-student",
        name: "EditJoinedStudent",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/EditStudent.vue"),
        meta: {
            routeName: "EditJoinedStudent",
            icon: "",
            title: "Edit Joined Student",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/groups",
        name: "Groups",
        component: () =>
            import("../views/adminPanel/classes/Groups.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Groups",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/attendance",
        name: "Attendance",
        component: () =>
            import("../views/adminPanel/classes/Attendance.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Attendance",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/teacher-attendance",
        name: "TeacherAttendance",
        component: () =>
            import("../views/adminPanel/classes/TeacherAttendance.vue"),
        meta: {
            icon: "mdi-teach",
            title: "TeacherAttendance",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/groups/group-details",
        name: "GroupDetails",
        props: true,
        component: () =>
            import("../views/adminPanel/classes/GroupDetails.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Group Details",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/groups/add-group",
        name: "AddGroup",
        component: () =>
            import("../views/adminPanel/classes/AddGroup.vue"),
        meta: {
            routeName: "AddGroup",
            icon: "",
            title: "Add Group",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "classes/groups/edit-group",
        name: "EditGroup",
        props: true,
        component: () =>
            import("../views/adminPanel/classes/AddGroup.vue"),
        meta: {
            routeName: "EditGroup",
            icon: "",
            title: "Edit Group",

            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "catchups",
        name: "CatchUps",
        component: () =>
            import("../views/adminPanel/catchups/CatchUps.vue"),
        meta: {
            icon: "fa-file-word",
            title: "CatchUps",
            subtitle: "Welcome to QS Learning CatchUps",
        },
    },
    {
        path: "tutors",
        name: "Tutors",
        component: () =>
            import("../views/adminPanel/tutors/Tutors.vue"),
        meta: {
            icon: "mdi-teach",
            title: "Tutors",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "tutors/profile",
        name: "TutorProfile",
        props: true,
        component: () =>
            import("../views/adminPanel/tutors/TutorProfile.vue"),
        meta: {
            icon: "",
            title: "Tutor Profile",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "tutors/add-tutor",
        name: "AddTutor",
        component: () =>
            import("../views/adminPanel/tutors/AddTutor.vue"),
        meta: {
            routeName: "AddTutor",
            icon: "fas fa-chalkboard-teacher",
            title: "Add Tutor",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "record-management/edit-joined-tutor",
        name: "EditJoinedTutor",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/EditTutor.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "EditJoinedTutor",
            title: "Edit Joined Tutor ",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },

    {
        path: "record-management/edit-call-data/:id",
        name: "EditCallData",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/AddCallData.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "EditCallData",
            title: "Edit Call Data",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },

    {
        path: "record-management/edit-tutor-data/:id",
        name: "EditTutorData",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/AddTutorData.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "EditTutorData",
            title: "Edit Tutor Data",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "record-management/add-tutor-data",
        name: "AddTutorData",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/AddTutorData.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "AddTutorData",
            title: "Add Tutor Data",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "record-management/add-call-data/",
        name: "AddCallData",
        props: true,
        component: () =>
            import("../views/adminPanel/record-management/AddCallData.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "AddCallData",
            title: "Add Call Data",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },


    {
        path: "tutors/edit-tutor/",
        name: "EditTutor",
        props: true,
        component: () =>
            import("../views/adminPanel/tutors/AddTutor.vue"),
        meta: {
            icon: "fas fa-chalkboard-teacher",
            routeName: "EditTutor",
            title: "Edit Tutor",
            subtitle: "Welcome to QS Learning Tutors",
        },
    },
    {
        path: "reports",
        name: "Reports",
        component: () =>
            import("../views/adminPanel/Reports/Index.vue"),
        meta: {
            icon: "mdi-palette-swatch",
            title: "Reports",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "reports/attendance",
        name: "AttendanceReport",
        component: () =>
            import("../views/adminPanel/Reports/Attendance/Index.vue"),
        meta: {
            icon: "fas fa-file",
            title: "Attendance Report",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "accounts",
        name: "Accounts",
        component: () =>
            import("../views/adminPanel/accounts/Accounts.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "accounts/add-invoice",
        name: "AddInvoice",
        component: () =>
            import("../views/adminPanel/accounts/AddInvoice.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Add Invoice",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "accounts/edit-invoice",
        name: "EditInvoice",
        props: true,
        component: () =>
            import("../views/adminPanel/accounts/AddInvoice.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Edit Invoice",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "accounts/add-tutor-earning",
        name: "AddTutorEarning",
        component: () =>
            import("../views/adminPanel/accounts/AddTutorEarning.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Add Tutor Earning",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "accounts/edit-tutor-earning",
        name: "EditTutorEarning",
        props: true,
        component: () =>
            import("../views/adminPanel/accounts/AddTutorEarning.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Edit Tutor Earning",
            subtitle: "Welcome to QS Learning Accounts",
        },
    },
    {
        path: "works",
        name: "Works",
        component: () =>
            import("../views/adminPanel/work/Work.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "works/add-work",
        name: "AddWork",
        component: () =>
            import("../views/adminPanel/work/AddWork.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Add Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "works/edit-work",
        name: "EditWork",
        props: true,
        component: () =>
            import("../views/adminPanel/work/AddWork.vue"),
        meta: {
            icon: "fas fa-file-word",
            title: "Edit Work",
            subtitle: "Welcome to QS Learning Works",
        },
    },
    {
        path: "settings",
        name: "Settings",
        component: () =>
            import("../views/adminPanel/settings/Settings"),
        meta: {
            icon: "fas fa-cog",
            title: "Settings",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/classes",
        name: "SettingClass",
        component: () =>
            import("../views/adminPanel/settings/Classes"),
        meta: {
            icon: "fas fa-cog",
            title: "Class",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/classes/add-classes",
        name: "AddClass",
        component: () =>
            import("../views/adminPanel/settings/AddClass.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Add Class",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/classes/edit-classes",
        name: "EditClass",
        props: true,
        component: () =>
            import("../views/adminPanel/settings/AddClass.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Edit Class",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/users",
        name: "Users",
        component: () =>
            import("../views/adminPanel/settings/Users.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Users",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/user-permissions",
        name: "UserPermissions",
        component: () =>
            import("../views/adminPanel/settings/UserPermissions.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Permissions",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/work-sheet",
        name: "SettingWorkSheet",
        component: () =>
            import("../views/adminPanel/settings/WorkSheet"),
        meta: {
            icon: "mdi-clipboard-text",
            title: "Work Sheet",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/users/add-user",
        name: "AddUser",
        component: () =>
            import("../views/adminPanel/settings/AddUser.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Add User",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/users/edit-user",
        name: "EditUser",
        props: true,
        component: () =>
            import("../views/adminPanel/settings/AddUser"),
        meta: {
            icon: "fas fa-cog",
            title: "Edit User",
            subtitle: "Welcome to QS Learning Settings",
        },
    },

    // todo: Roles
    {
        path: "roles",
        name: "Roles",
        component: () =>
            import("../views/adminPanel/roles/Roles.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Roles",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "roles/add-role",
        name: "AddRole",
        component: () =>
            import("../views/adminPanel/roles/AddRole.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Add Role",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "roles/edit-role",
        name: "EditRole",
        props: true,
        component: () =>
            import("../views/adminPanel/roles/AddRole.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Edit Role",
            subtitle: "Welcome to QS Learning Settings",
        },
    },

    {
        path: "settings/discounts",
        name: "Discounts",
        component: () =>
            import("../views/adminPanel/settings/Discounts"),
        meta: {
            icon: "fas fa-cog",
            title: "Discounts",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/configurations",
        name: "Configurations",
        component: () =>
            import("../views/adminPanel/settings/Configurations"),
        meta: {
            icon: "fas fa-cog",
            title: "Configurations",
            subtitle: "Welcome to QS Learning Configurations",
        },
    },
    {
        path: "settings/discount/add-discount",
        name: "AddDiscount",
        component: () =>
            import("../views/adminPanel/settings/AddDiscount"),
        meta: {
            icon: "fas fa-cog",
            title: "Add Discount",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "settings/discount/edit-discount",
        name: "EditDiscount",
        props: true,
        component: () =>
            import("../views/adminPanel/settings/AddDiscount"),
        meta: {
            icon: "fas fa-cog",
            title: "Edit Discount",
            subtitle: "Welcome to QS Learning Settings",
        },
    },

    {
        path: "work-sheet",
        name: "WorkSheet",
        props: true,
        component: () =>
            import("../views/adminPanel/WorkSheet/index.vue"),
        meta: {
            icon: "mdi-clipboard-text",
            title: "Work Sheet",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
    {
        path: "tutor/sessions",
        name: "TutorSessions",
        props: true,
        component: () =>
            import("../views/adminPanel/tutors/Sessions.vue"),
        meta: {
            icon: "fas fa-cog",
            title: "Tutor Sessions",
            subtitle: "Welcome to QS Learning Settings",
        },
    },
];

export default Links;